import LocalMultiplayerIntroduction from './localmultiplayerintroduction'

export default LocalMultiplayerIntroduction